module.exports = __webpack_public_path__ + "img/JO.2ec80b6c.svg";